module.exports = __webpack_public_path__ + "static/media/scheduled-check-icon.aa0db72e.svg";